import {
  ADD_LAYOUT_SUCCESS,
  DELETE_LAYOUT_SUCCESS,
  EDIT_LAYOUT_SUCCESS,
  RESET_LAYOUTS,
  SET_CURRENT_LAYOUT,
  SET_LAYOUTS,
  SHOW_OVERLAYLAYOUT,
  UPDATE_NEWLY_LAYOUT
} from "../actionTypes/layout";

export const setLayouts = (type, layouts) => ({
  type: SET_LAYOUTS,
  payload: { type, layouts }
});

export const setCurrentLayout = (type, layout) => ({
  type: SET_CURRENT_LAYOUT,
  payload: { type, layout }
});

export const addNewLayoutSucess = (type, Layout) => ({
  type: ADD_LAYOUT_SUCCESS,
  payload: { type, Layout }
});

export const deleteNewLayoutSucess = (type, name) => ({
  type: DELETE_LAYOUT_SUCCESS,
  payload: { type, name }
});

export const editLayoutSucess = (type, Layout) => ({
  type: EDIT_LAYOUT_SUCCESS,
  payload: { type, Layout }
});

export const updateNewlyAddedLayout = (type, Layout) => ({
  type: UPDATE_NEWLY_LAYOUT,
  payload: { type, Layout }
});

export const resetLayoutsToEmpty = () => ({
  type: RESET_LAYOUTS
});

export const showOverlayLoader = value => ({
  type: SHOW_OVERLAYLAYOUT,
  payload: { value }
});
